<template>
  <div>

    <toggle-collapse>
      <b-card style="position: relative" :title="$t('Filter Plans')">
        <b-row class="mt-2">
          <b-col sm="12" md="6">
            <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="plansFilterRequest.owners" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[...owners]" :reduce="d => d.id"
                v-on:input="$emit('plansFilterChanged', plansFilterRequest),refliterContractByWoners(plansFilterRequest.owners)" />
                
                 
              <small v-if="errors && ('owners' in errors)" class="text-danger">
                {{ $t(errors['owners'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
              <v-select multiple  :close-on-select="false"
                 v-model="plansFilterRequest.contracts"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[...contracts]" :reduce="d => d.id" 
                v-on:input="$emit('plansFilterChanged', plansFilterRequest)" />
              <small v-if="errors && ('contracts' in errors)" class="text-danger">
                {{ $t(errors['contracts'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </toggle-collapse>
   
  </div>
</template>
  
  <script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, VBTooltip,
  BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import { ref } from '@vue/composition-api'
import PlansFilterLogic from './logic'
import filterForm from '@/views/modules/plans/filters/planFilterForm'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
export default {
  name: 'PlansFilter',
  props:['planType'],
  components: {
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner, BInputGroupAppend,
    ToggleCollapse
  },
  directives: {
    Ripple, 'b-tooltip': VBTooltip,
  },

  setup(props,{root}) {
    const filter = ref(null);
    const filterOn = ref([]); 
    const {  owners, contracts,contracts_orig, plans, reFilterPlans } = filterForm(props.planType)
    const {  plansFilterRequest, errors, loading} = PlansFilterLogic() 

    const refliterContractByWoners=(owners)=>{
          
          let result=contracts_orig.value.filter((i)=>owners.includes(i.contractor_id))
         
           contracts.value=result;
           if(owners.length==0){
            contracts.value=contracts_orig.value;
          }
         
        }
    return {     
      plansFilterRequest,
      loading,
      errors,
      owners, contracts, plans, reFilterPlans,
      filter,
      filterOn,
      refliterContractByWoners
    }

  },

}
</script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';  
  .repeater-form {
    overflow: hidden;
    transition: .35s height;
  }
  
  .group-row {
    background-color: #ddd;
  }
  </style>
  